export enum enumPayoutAccountStatus {
  ATTESA_DOC = 1,
  ATTESA_VERIFICA = 2,
  VERIFICATO = 3,
  RIFIUTATO = 4,
}
export enum enumPayoutTransferStatus {
  IN_LAVORAZIONE = 1,
  EVASA = 2,
  ANNULLATA = 3,
}